import { INSURANCE_TYPES_NAMES } from 'constants/insurance';
import { compareListWithPriorities } from './sorting';

export const reorderPolicy = (policyTypes) => {
  const sortMethod = compareListWithPriorities(Object.values(INSURANCE_TYPES_NAMES))

  return policyTypes.sort(sortMethod);
};
